// Application Constants

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  USER_DASHBOARD: '/dashboard',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/dashboard/users',
  ADMIN_TOKENS: '/admin/dashboard/tokens',
  ADMIN_DRAWS: '/admin/dashboard/draws',
  ADMIN_WINNERS: '/admin/dashboard/winners',
  ADMIN_PAYMENTS: '/admin/dashboard/payments',
  ADMIN_INQUIRIES: '/admin/dashboard/inquiries',
  ADMIN_SETTINGS: '/admin/dashboard/settings',
  TOKEN_DOWNLOAD: '/token/:id',
};

export const COLLECTIONS = {
  ADMINS: 'admins',
  USERS: 'users',
  VIP_TOKENS: 'vipTokens',
  TOKEN_IMAGES: 'tokenImages',
  TOKEN_DOWNLOAD_LINKS: 'tokenDownloadLinks',
  PRIZE_DRAWS: 'prizeDraws',
  WINNERS: 'winners',
  PAYMENTS: 'payments',
  INQUIRIES: 'inquiries',
  SETTINGS: 'settings',
  ARMY_FUNDS: 'armyFunds',
  STATS: 'stats',
  PRODUCTS: 'products',
};

export const APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const INQUIRY_STATUS = {
  NEW: 'new',
  RESPONDED: 'responded',
};

export const DRAW_STATUS = {
  UPCOMING: 'upcoming',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

export const DEFAULT_SETTINGS = {
  tokenPrice: 0, // Tokens are now free
  minTokensForDraw: 50,
  contactEmail: 'support@offerlifetime.com',
  whatsappNumber: '+91 8818001860',
  armyFundPercentage: 10,
};

export const CONTACT_INFO = {
  email: 'support@offerlifetime.com',
  whatsapp: '+91 8818001860',
  address: 'VPO BATTA TH. KALAYAT DISST. KAITHAL HARYANA INDIA',
};

export const ERROR_MESSAGES = {
  AUTH: {
    INVALID_EMAIL: 'Please enter a valid email address',
    WEAK_PASSWORD: 'Password must be at least 6 characters',
    EMAIL_IN_USE: 'This email is already registered',
    USER_NOT_FOUND: 'No account found with this email',
    WRONG_PASSWORD: 'Incorrect password',
    TOO_MANY_REQUESTS: 'Too many failed attempts. Please try again later',
  },
  GENERAL: {
    NETWORK_ERROR: 'Network error. Please check your connection',
    UNKNOWN_ERROR: 'An unexpected error occurred',
    PERMISSION_DENIED: 'You do not have permission to perform this action',
  },
};

export const SUCCESS_MESSAGES = {
  AUTH: {
    LOGIN_SUCCESS: 'Login successful!',
    REGISTER_SUCCESS: 'Account created successfully!',
    LOGOUT_SUCCESS: 'Logged out successfully',
  },
  ADMIN: {
    USER_APPROVED: 'User approved successfully',
    USER_REJECTED: 'User rejected',
    TOKEN_ISSUED: 'VIP token issued successfully',
    DRAW_CREATED: 'Prize draw created successfully',
    WINNER_SELECTED: 'Winner selected successfully',
    SETTINGS_SAVED: 'Settings saved successfully',
  },
};
